import React from "react";
import { SkillsContent } from "../../components/SkillsContent/SkillsContent";
const Skills = () => {
  return (
    <>
      <SkillsContent />
    </>
  );
};

export default Skills;
